export default __webpack_public_path__ + "static/media/poster18.931d6ec2.png";